"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.appearances = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _feCoIcon = require("@domain-group/fe-co-icon");
var _textInput = _interopRequireDefault(require("../text-input"));
var styles = _interopRequireWildcard(require("../../styles/stepper"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var NUMBERS_ONLY = /^\d+$/;
var limitValue = (min, max) => value => String(Math.min(Math.max(Number(value), min), max));
var appearances = exports.appearances = {
  clean: 'clean',
  cleanThin: 'cleanThin',
  default: '',
  thin: 'thin',
  wide: 'wide'
};
var Stepper = _ref => {
  var appearance = _ref.appearance,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    format = _ref.format,
    groupLabel = _ref.groupLabel,
    iconsSize = _ref.iconsSize,
    id = _ref.id,
    isInvalid = _ref.isInvalid,
    max = _ref.max,
    min = _ref.min,
    name = _ref.name,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    required = _ref.required,
    step = _ref.step,
    textInputFontSize = _ref.textInputFontSize,
    textInputProps = _ref.textInputProps,
    type = _ref.type,
    valueProp = _ref.value;
  var _useState = (0, _react.useState)(valueProp || defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setValue = _useState2[1];
  var isDecrementDisabled = currentValue <= min;
  var isIncrementDisabled = currentValue >= max;
  var onLimit = limitValue(min, max);
  var onValueChange = value => {
    setValue(value);
    onChange({
      target: {
        name,
        type,
        value
      }
    });
  };
  var onValueClick = value => {
    setValue(value);
    onChange({
      target: {
        name,
        type,
        value
      }
    });
  };
  var onTextInputChange = event => {
    event.preventDefault();
    var value = event.target.value;
    if (value === '') {
      onValueChange(String(min));
      return;
    }
    if (NUMBERS_ONLY.test(value)) {
      onValueChange(onLimit(value));
    }
  };
  var onButtonClick = stepValue => event => {
    event.preventDefault();
    if (!NUMBERS_ONLY.test(currentValue)) {
      onValueClick(onLimit(min + stepValue));
      return;
    }
    var newValue = onLimit(Number(currentValue) + stepValue);
    onValueClick(newValue);
  };
  return (0, _core.jsx)("div", {
    css: styles.stepper({
      appearance
    }),
    role: "group",
    "aria-label": groupLabel
  }, (0, _core.jsx)("button", {
    "aria-label": "decrement",
    css: styles.actionButton,
    disabled: disabled || isDecrementDisabled,
    onClick: onButtonClick(-step),
    tabIndex: "-1",
    type: "button"
  }, (0, _core.jsx)(_feCoIcon.MinusIcon, {
    size: "custom",
    css: styles.actionIcon({
      size: iconsSize,
      isDisabled: disabled || isDecrementDisabled
    })
  })), (0, _core.jsx)("div", {
    css: styles.inputWrapper({
      appearance
    })
  }, (0, _core.jsx)(_textInput.default, _extends({}, textInputProps, {
    type: type,
    css: styles.input({
      appearance,
      fontSize: textInputFontSize,
      isInvalid
    }),
    defaultValue: defaultValue,
    disabled: disabled,
    format: format,
    id: id,
    isInvalid: isInvalid,
    max: max,
    min: min,
    name: name,
    onChange: onTextInputChange,
    pattern: "\\d*",
    placeholder: placeholder,
    required: required,
    step: String(step),
    value: currentValue
  }))), (0, _core.jsx)("button", {
    "aria-label": "increment",
    css: styles.actionButton,
    disabled: disabled || isIncrementDisabled,
    onClick: onButtonClick(step),
    tabIndex: "-1",
    type: "button"
  }, (0, _core.jsx)(_feCoIcon.AddIcon, {
    size: "custom",
    css: styles.actionIcon({
      size: iconsSize,
      isDisabled: disabled || isIncrementDisabled
    })
  })));
};
Stepper.propTypes = {
  appearance: _propTypes.default.oneOf(Object.values(appearances)),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  disabled: _propTypes.default.bool,
  format: _propTypes.default.func,
  groupLabel: _propTypes.default.string,
  iconsSize: _propTypes.default.string,
  id: _propTypes.default.string,
  isInvalid: _propTypes.default.bool,
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  required: _propTypes.default.bool,
  step: _propTypes.default.number,
  textInputFontSize: _propTypes.default.string,
  textInputProps: _propTypes.default.shape(_textInput.default.propTypes),
  type: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
Stepper.defaultProps = {
  appearance: '',
  defaultValue: '',
  disabled: false,
  format: undefined,
  groupLabel: 'stepper',
  iconsSize: '32px',
  id: undefined,
  isInvalid: false,
  max: 100,
  min: 0,
  name: undefined,
  onChange() {},
  onClick() {},
  placeholder: '',
  required: false,
  step: 1,
  textInputFontSize: '16px',
  textInputProps: _textInput.default.defaultProps,
  type: 'number',
  value: ''
};
var _default = exports.default = Stepper;